import { Badge } from "@/shared/components/ui/badge";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/shared/components/ui/tooltip";
import type { GuardOtHint } from "./useGuardOvertimeHints";

export function GuardOtBadge({ hint }: { hint?: GuardOtHint }) {
  if (!hint || !hint.status) return null;
  const over = hint.status === "over";
  const label = over ? `→ OT (+${(hint.afterHours - hint.thresholdHours).toFixed(1)}h)` : "Near limit";
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span>
            <Badge tone={over ? "bad" : "warn"} className="ml-2">
              {label}
            </Badge>
          </span>
        </TooltipTrigger>
        <TooltipContent>
          {hint.projectedHours.toFixed(1)} + this shift = {hint.afterHours.toFixed(1)}h this week (limit{" "}
          {hint.thresholdHours}h)
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
